import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar';
import './transferencias.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useUnits } from '../../context/unitsContext';
import { useInternals } from '../../context/internalContext';
import { useUsers } from '../../context/usersContext';
import Modal from '../../components/modal';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import Usuario from '../../assets/icons/userplus.svg';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import { normalizeUnitId } from '../../utils/unitScope';
import useSubmitLock from '../../utils/useSubmitLock';

function ChangeCell() {
  const { listCells, listPavillions } = useUnits();
  const { changeCell, listInternalsByCell } = useInternals();
  const {
    effectiveUnitId,
    requireWriteUnit,
  } = useUsers();
  const [destination, setDestination] = useState('');
  const [reason, setReason] = useState('');
  const [pavilions, setPavilions] = useState([]);
  const [selectedInternals, setSelectedInternals] = useState([]);
  const [isInternalModalOpen, setIsInternalModalOpen] = useState(false);
  const [isCellModalOpen, setIsCellModalOpen] = useState(false);
  const [selectedPavilion, setSelectedPavilion] = useState('');
  const [currentCells, setCurrentCells] = useState([]);
  const [modalPavilion, setModalPavilion] = useState('');
  const [modalCells, setModalCells] = useState([]);
  const [modalDestination, setModalDestination] = useState('');
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();
  const getCellPavilionId = (cell) => Number(
    cell?.pavilion?.id ?? cell?.pavilion_id ?? cell?.pavilion
  );

  const getInternalUnitId = (internal) => normalizeUnitId(
    internal?.unit?.id ?? internal?.unit_id ?? internal?.unit
  );

  useEffect(() => {
    const fetchPavilions = async () => {
      if (effectiveUnitId === null || effectiveUnitId === undefined || String(effectiveUnitId) === '') {
        setPavilions([]);
        return;
      }

      const response = await listPavillions({ unit: effectiveUnitId });
      const allPavilions = Array.isArray(response?.results) ? response.results : [];
      const filteredPavilions = allPavilions.filter(
        (pavilion) => String(pavilion?.unit) === String(effectiveUnitId)
      );
      setPavilions(filteredPavilions);
    };

    fetchPavilions();
  }, [listPavillions, effectiveUnitId]);

  useEffect(() => {
    const fetchCurrentCells = async () => {
      if (!selectedPavilion) {
        setCurrentCells([]);
        return;
      }

      const pavilionId = Number(selectedPavilion);
      const response = await listCells({ pavilion: pavilionId });
      const allCells = Array.isArray(response?.results) ? response.results : [];
      const filteredCells = allCells.filter((cell) => getCellPavilionId(cell) === pavilionId);
      setCurrentCells(filteredCells);
    };

    fetchCurrentCells();
  }, [selectedPavilion, listCells]);

  useEffect(() => {
    const fetchModalCells = async () => {
      if (!modalPavilion) {
        setModalCells([]);
        return;
      }

      const pavilionId = Number(modalPavilion);
      const response = await listCells({ pavilion: pavilionId });
      const allCells = Array.isArray(response?.results) ? response.results : [];
      const filteredCells = allCells.filter((cell) => getCellPavilionId(cell) === pavilionId);
      setModalCells(filteredCells);
    };

    fetchModalCells();
  }, [modalPavilion, listCells]);

  useEffect(() => {
    setSelectedPavilion('');
    setDestination('');
    setCurrentCells([]);
    setModalPavilion('');
    setModalDestination('');
    setModalCells([]);
    setSelectedInternals([]);
  }, [effectiveUnitId]);

  const handleInternalSelect = (internal) => {
    if (selectedInternals.some(selected => selected.id === internal.id)) {
      toast.warning("Este interno já foi adicionado.");
      return;
    }

    setSelectedInternals((prev) => [...prev, internal]);
    setIsInternalModalOpen(false);
  };


  const removeInternalFromList = (internalId) => {
    setSelectedInternals((prev) => prev.filter(internal => internal.id !== internalId));
  };

  const addAllInternalsFromCell = async () => {
    if (!modalDestination) {
      toast.warning("Selecione uma cela.");
      return;
    }

    try {
      const response = await listInternalsByCell(modalDestination);
      if (response && Array.isArray(response.results)) {
        const internalsFromCell = response.results.filter(
          internal => !selectedInternals.some(selected => selected.id === internal.id)
        );

        setSelectedInternals(prev => [...prev, ...internalsFromCell]);
        setIsCellModalOpen(false);
      } else {
        toast.warning("Nenhum interno encontrado para essa cela.");
      }
    } catch (error) {
      console.error("Erro ao buscar internos da cela:", error);
      toast.error("Erro ao buscar internos.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      const writeUnit = requireWriteUnit();
      if (!writeUnit.ok) {
        toast.warning(writeUnit.message);
        return;
      }

      if (selectedInternals.length === 0) {
        toast.warning("Nenhum interno selecionado.");
        return;
      }

      const destinationCell = currentCells.find((cellItem) => String(cellItem.id) === String(destination));
      const destinationPavilion = destinationCell
        ? pavilions.find((pavilion) => String(pavilion.id) === String(selectedPavilion))
        : null;

      if (!destinationCell || !destinationPavilion) {
        toast.warning("Selecione um pavilhão e uma cela válidos.");
        return;
      }

      if (String(destinationPavilion.unit) !== String(writeUnit.unitId)) {
        toast.warning("A cela selecionada não pertence à unidade de atuação.");
        return;
      }

      const hasInternalsFromOtherUnit = selectedInternals.some((internal) => {
        const internalUnitId = getInternalUnitId(internal);
        if (internalUnitId === null) return false;
        return String(internalUnitId) !== String(writeUnit.unitId);
      });

      if (hasInternalsFromOtherUnit) {
        toast.warning("Existem internos fora da unidade de atuação selecionada.");
        return;
      }

      const cellChangeData = selectedInternals.map(internal => ({
        cell: parseInt(destination, 10),
        internal: internal.id,
        old_cell: internal.cell,
        reason: reason.trim(),
      }));

      let successCount = 0;

      for (const data of cellChangeData) {
        const result = await changeCell(data); // Assumindo que já trata erros
        if (result?.success) {
          successCount++;
        }
      }

      if (successCount > 0) {
        toast.success(`${successCount} transferência(s) realizada(s) com sucesso!`);
      }

      // Limpar os campos após sucesso
      setDestination('');
      setReason('');
      setSelectedInternals([]);
    });
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <div className="admission-header">
          <div className="admission-title">
            <h2>Mudança de cela</h2>
            <p>Transferência interna de internos entre celas.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="change-cell-layout">
          <div className="health-card">
            <div className="health-grid-two">
              <div className="health-option-set">
                <label>Novo pavilhão</label>
                <select
                  value={selectedPavilion}
                  onChange={(e) => {
                    setSelectedPavilion(e.target.value);
                    setDestination('');
                  }}
                  required
                >
                  <option value="">Selecione o pavilhão</option>
                  {pavilions.map((pavilion) => (
                    <option key={pavilion.id} value={pavilion.id}>{pavilion.name}</option>
                  ))}
                </select>
              </div>
              <div className="health-option-set">
                <label>Nova cela</label>
                <select
                  value={destination}
                  onChange={(e) => setDestination(e.target.value)}
                  required
                  disabled={!selectedPavilion}
                >
                  <option value="">Selecione a nova cela</option>
                  {currentCells.map((cell) => (
                    <option key={cell.id} value={cell.id}>{cell.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="health-option-set" style={{ marginTop: 12 }}>
              <label>Razão da mudança</label>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder='Descreva a razão da mudança'
                required
              />
            </div>
          </div>

          <div className="health-card change-cell-table">
            <div className="change-cell-actions">
              <button type="button" onClick={() => setIsInternalModalOpen(true)} className="btnAdcionar">
                <img src={Usuario} alt='Incone' /> Adicionar interno
              </button>
              <button type="button" onClick={() => setIsCellModalOpen(true)} className="btnAdcionar">
                <div>
                  <img src={Usuario} alt='Incone' />
                  <img src={Usuario} alt='Incone' />
                  <img src={Usuario} alt='Incone' />
                </div>
                Adicionar todos da cela
              </button>
            </div>
            <div className="internals-table">
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Pavilhão atual</th>
                    <th>Cela atual</th>
                    <th>Excluir</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedInternals.map((internal) => (
                    <tr key={internal.id}>
                      <td>{internal.name}</td>
                      <td>{internal.pavilion_name}</td>
                      <td>{internal.cell_name}</td>
                      <td>
                        <button
                          type="button"
                          className="change-cell-remove"
                          onClick={() => removeInternalFromList(internal.id)}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="admission-actions">
              <button type="submit" className="btnConfirmar" disabled={isSubmitting}>
                <FontAwesomeIcon icon={faCheck} />
                <span>{isSubmitting ? 'Salvando...' : 'Salvar transferência'}</span>
              </button>
            </div>
          </div>
        </form>

        {/* Modal para adicionar internos */}
        {isInternalModalOpen && (
          <Modal title="Adicionar Interno" isOpen={isInternalModalOpen} closeModal={() => setIsInternalModalOpen(false)}>
            <Titulo
              children={
                <SearchInternal onSelect={handleInternalSelect} />
              }
            />
          </Modal>
        )}

        {/* Modal para adicionar todos da cela */}
        {isCellModalOpen && (
          <Modal title="Adicionar Todos da Cela" isOpen={isCellModalOpen} closeModal={() => setIsCellModalOpen(false)}>
            <div className="health-grid-two">
              <div className="health-option-set">
                <label>Pavilhão</label>
                <select
                  value={modalPavilion}
                  onChange={(e) => {
                    setModalPavilion(e.target.value);
                    setModalDestination('');
                  }}
                  required
                >
                  <option value="">Selecione o pavilhão</option>
                  {pavilions.map((pavilion) => (
                    <option key={pavilion.id} value={pavilion.id}>{pavilion.name}</option>
                  ))}
                </select>
              </div>
              <div className="health-option-set">
                <label>Cela</label>
                <select
                  value={modalDestination}
                  onChange={(e) => setModalDestination(e.target.value)}
                  required
                  disabled={!modalPavilion}
                >
                  <option value="">Selecione a cela</option>
                  {modalCells.map((cell) => (
                    <option key={cell.id} value={cell.id}>{cell.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="admission-actions" style={{ marginTop: 16 }}>
              <button type="button" className="social-submit-button" onClick={addAllInternalsFromCell}>
                Adicionar todos
              </button>
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
}

export default ChangeCell;
